import { Grid, Zoom } from "@mui/material"
import React, { useContext, useMemo, useState } from "react"
import { BSBimModelListContext } from "../../../../../../core/context/beem-shot/BSBimModel/BSBimModelContextList"
import { BSBimModel } from "../../../../../../core/dto/beem-shot/BSBimModel/BSBimModel"
import { BSBimModelListEmpty } from "./BSBimModelListEmpty"
import { BSBimModelListHeader } from "./BSBimModelListHeader"
import { BSBimModelRow } from "./BSBimModelRow"
import { BSBimModelSearchHeader } from "./BSBimModelSearchHeader"

export function BSBimModelList(): React.JSX.Element {
  const { bsBimModelListByProject } = useContext(BSBimModelListContext)

  const [hideLinkedBimModel, setHideLinkedBimModel] = useState<boolean>(false)
  const [searchValue, setSearchValue] = useState<string>("")

  const bimModelToshow = useMemo(() => {
    const list = bsBimModelListByProject

    if (hideLinkedBimModel) {
      return list.filter((model) => model.variantCount !== 0)
    }

    if (searchValue !== "") {
      return list.filter((model) => model.fileName.toLowerCase().includes(searchValue.toLowerCase()))
    }

    return list
  }, [bsBimModelListByProject, hideLinkedBimModel, searchValue])

  return bsBimModelListByProject.length > 0 ? (
    <Grid item container>
      <BSBimModelSearchHeader
        hideLinkedBimModel={hideLinkedBimModel}
        setHideLinkedBimModel={setHideLinkedBimModel}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
      />
      <BSBimModelListHeader />

      <Grid container gap={1}>
        {bimModelToshow.map((bsBimModel: BSBimModel, index) => (
          <Zoom in style={{ transitionDelay: `${index * 150}ms` }} key={bsBimModel.id}>
            <Grid item container xs={12} key={bsBimModel.id} rowGap={1}>
              <BSBimModelRow bsBimModel={bsBimModel} />
            </Grid>
          </Zoom>
        ))}
      </Grid>
    </Grid>
  ) : (
    <Grid item xs={12} height="100%" display="flex" alignItems="center" justifyContent="center">
      <BSBimModelListEmpty />
    </Grid>
  )
}
